<template>
    <div>
        <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="closeDrawer" :size="600"
            class="margin_top_40" :wrapperClosable="false" :modal='false' :destroy-on-close='true' append-to-body>
            <div class="steps">
                <div class="step-item" v-for="(item, index) in nodeList" :key="index">
                    <span class="step-dot"></span>
                    <div class="step-content">
                        <div class="step-title">{{ item.nodeName }}</div>
                        <!-- <div class="step-desc">{{ item.userLst.length }}人审批</div> -->
                        <div class="step-desc" v-if="item.nodeName !== '开始' && item.nodeName !== '结束'">{{
                            `${item.isSign === false ? '单人' : '同时'}审批` }}</div>
                    </div>
                    <div class="step-user" v-if="item.userLst.length > 0">
                        <div v-for="(v, i) in item.usersName.length + 1" :key="i"
                            :class="i !== item.usersName.length ? 'name_box' : 'plus_box'"
                            @click="showDialog(item, index, i === item.users.length ? 'add' : 'del', i)">
                            <span v-if="item.usersName[i]">{{ item.usersName[i] }}</span>
                        </div>

                        <!-- <div v-for="(v, i) in item.users.length + 1" :key="i"
                            :class="i !== item.users.length ? 'name_box' : item.users.length !== item.userLst.length ? 'plus_box' : 'plus_box_display'"
                            @click="handleMenu(item.userLst, index, $event, i === item.users.length ? 'add' : 'del', i)">
                            <span v-if="item.users[i]">{{ item.users[i].value }}</span>
                        </div> -->
                    </div>
                    <div class="step-line"></div> <!-- 添加这一行 -->
                </div>
            </div>
            <slot></slot>
            <my-dialog title="审批人员" :visible.sync="dialogVisible" append-to-body>
                <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入人员名称"
                    v-model="itemData.users" :data="itemData.userLst" :titles="['待选审批人', '已选审批人']"
                    :props="{ key: 'keyId', label: 'value' }" @change="changeRightUser" ref="myTransfer"
                    class="my_transfer">
                </el-transfer>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitDialog()">
                        保存
                    </el-button>
                </div>
            </my-dialog>
            <div class="drawer-footer">
                <el-button size="small" icon="el-icon-check" :loading="saveloading" class="title"
                    @click="submitForm('editForm')">
                    送审
                </el-button>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import {
    GetSubmitStructure,
    CreateWorkflow
} from "../../api/workFlowApi.js";
export default {
    name: 'submitApproval',
    props: {},
    data() {
        return {
            saveloading: false,
            editFormVisible: false,
            dialogVisible: false,
            title: "新增",
            editForm: {
                businessCode: '',
                ronter: '',
                businessName: '',
                processId: '',
                nodes: [],
                businessData: '',
                businessData2: ''
            },
            nodeList: [],
            itemData: {
                userLst: [],
                users: []
            },
            itemIndex: 0,
            filterMethod(query, item) {
                return item.value.indexOf(query) > -1;
            }
        };
    },
    components: {
    },
    created() {

    },
    methods: {
        // 显示弹框
        showDialog(itemData, itemIndex, effect, i) {
            switch (effect) {
                case 'add':
                    this.itemData = JSON.parse(JSON.stringify(itemData));
                    this.itemIndex = itemIndex
                    this.$nextTick(() => {
                        // 清空左边搜索
                        this.$refs.myTransfer.$children["0"]._data.query = '';
                        // 清空右边搜索
                        this.$refs.myTransfer.$children["3"]._data.query = '';
                    })
                    this.dialogVisible = true;
                    break;
                case 'del':
                    itemData.users.splice(i, 1)
                    itemData.usersName.splice(i, 1)
                    break;
                default:
                    break;
            }
        },
        submitDialog() {
            this.nodeList[this.itemIndex] = this.itemData
            this.dialogVisible = false;
        },
        // 获取名称
        changeRightUser($event) {
            this.itemData.usersName = this.itemData.userLst.filter(item => $event.includes(item.keyId)).map(v => v.value)
        },
        changeString() {
            let nodeList = JSON.parse(JSON.stringify(this.nodeList))
            let data = nodeList.map(item => {
                delete item.userLst
                delete item.usersName
                if (item.users) {
                    item.users = item.users.join()
                }
                return item
            })
            return data
        },
        // 编辑、增加页面保存方法
        submitForm() {
            this.editForm.nodes = this.changeString()
            CreateWorkflow(this.editForm)
                .then((res) => {
                    if (res.code == 1) {
                        this.$emit('createWorkflowSuccess');
                        this.$message({
                            type: "success",
                            message: "送审成功！",
                        });
                        this.closeDrawer('success')
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                        this.saveloading = false;
                    }
                })
                .catch((err) => {
                    this.editFormVisible = false;
                    this.saveloading = false;
                    this.$message.error("送审失败，请稍后再试！");
                });
        },
        //显示编辑界面
        editShow(row) {
            if (row != undefined && row != "undefined") {
                this.title = "送审";
                this.isEdit = false;
                this.editForm = row
                this.editForm.nodes = []
                let parameter = {
                    businessCode: row.businessCode,
                };
                GetSubmitStructure(parameter)
                    .then((res) => {
                        if (res.code == 1) {
                            this.nodeList = res.data.map(item => {
                                item.users = []
                                item.usersName = []
                                return item
                            })
                            this.editFormVisible = true;
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch((err) => {
                        this.$message.error("加载失败，请稍后再试！");
                    });
            }
        },
        // 关闭编辑、增加弹出框
        closeDrawer(val) {
            if (!this.editFormVisible) {
                return
            }
            if (val !== 'success') {
                this.$emit('cancelWorkflow', this.editForm.processId);
            }
            this.saveloading = false;
            this.editFormVisible = false;
            this.$data.editForm = this.$options.data.call(this).editForm;
            this.$data.nodeList = this.$options.data.call(this).nodeList;
        },
    },
};
</script>
<style scoped lang="scss">
.steps {
    padding: 0 50px;
}

.step-item {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    min-height: 120px;

    .step-dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ccc;
        position: absolute;
        top: 8px;
        left: -15px;
    }

    .step-content {
        display: flex;
        flex-direction: column;

        .step-title {
            font-weight: bold;
            font-size: 18px;
        }

        .step-desc {
            font-size: 16px;
            padding-top: 4px;
            color: #999;
        }
    }

    .step-user {
        width: 80%;
        // text-align: right;
        // display: flex;
        // justify-content: flex-end;
        // flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(5, 60px);
        grid-gap: 12px;

        .plus_box {
            width: 60px;
            height: 60px;
            border: dashed 1px #ccc;
            cursor: pointer;
            position: relative;
            border-radius: 12px;
        }

        .plus_box::before {
            content: '';
            width: 0;
            height: 40px;
            border-left: 2px solid #ccc;
            position: absolute;
            top: calc(30px - 20px);
            left: 30px;
        }

        .plus_box::after {
            content: '';
            width: 40px;
            height: 0px;
            border-top: 2px solid #ccc;
            position: absolute;
            left: calc(30px - 20px);
            top: 30px;
        }

        .plus_box:hover,
        .plus_box:hover:before,
        .plus_box:hover:after {
            border-color: #3ba8f3;
        }

        .plus_box_display {
            display: none;
        }

        .name_box {
            width: 60px;
            height: 60px;
            border: solid 1px #ccc;
            cursor: pointer;
            position: relative;
            line-height: 60px;
            text-align: center;
            border-radius: 12px;
            overflow: hidden;
        }

        .name_box::before {
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            transition: all .3s linear;
            background-color: #ffffff;
            background-image: url('../../assets/img/flow/clear.png');
            background-size: 50% 50%;
            background-position: center center;
            background-repeat: no-repeat;
            opacity: 0;
        }

        .name_box:hover::before {
            opacity: 1;
        }
    }

    .step-line {
        position: absolute;
        top: 22px;
        /* 根据圆点的尺寸调整 */
        left: -11px;
        /* 将竖线居中对齐 */
        bottom: -5px;
        /* 调整竖线的长度 */
        width: 2px;
        background-color: #ccc;
    }
}

.step-item:last-child .step-line {
    display: none;
}

::v-deep .my_transfer .el-transfer-panel {
    height: calc(100vh - 29.125rem);
    width: 28.5rem;

    .el-transfer-panel__list.is-filterable {
        height: 30rem;
    }
}

::v-deep .el-drawer {
    width: 600px !important;
}
</style>